module.exports = __webpack_public_path__ + "img/alex-customize-leaf1.2a13a30a.png";